import { tooltipFactory } from '@milkdown/kit/plugin/tooltip'

export const inlineLatexTooltip = tooltipFactory('INLINE_LATEX')
